export default "__VITE_ASSET___uaELxMo__"